import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.texto)?_c(VTooltip,{attrs:{"bottom":"","max-width":"320"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({staticClass:"ml-1 dica-metrica",attrs:{"x-small":"","color":_vm.cor},on:{"click":function($event){$event.stopPropagation();}}},'v-icon',attrs,false),on),[_vm._v("mdi-information-outline")])]}}],null,false,3190972602)},[_c('span',[_vm._v(_vm._s(_vm.texto))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }